import Vue from "vue";
//import queryString from "query-string";
import router from "./../../router";
import { i18n } from "./../../main";

export async function fetchServicios({ commit }, filtro) {
  try {
    console.log("Token: " + window.localStorage.getItem("_token"));
    console.log("Filtro: " + JSON.stringify(filtro));

    let ruta = Vue.prototype.$apiRoute + "expediciones/todasV2/";
    let res = await fetch(ruta, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("_token")
      },
      body: JSON.stringify(filtro)
    });

    if (res.ok) {
      let resJson = await res.json();
      commit("setServices", resJson);
      commit("setFiltro", filtro);
      commit("setNecesitaRecargar", false);
    } else throw true;
  } catch (error) {
    Vue.prototype.$toast(i18n.t("mensajes.inicioSesion"), {
      color: "blue"
    });
    commit("Auth/logout", null, { root: true });
    router.push("login");
  }
}

export async function generarManifiesto({ commit }, filtro) {
  try {
    console.log("Token: " + window.localStorage.getItem("_token"));
    let ruta = Vue.prototype.$apiRoute + "manifiesto/";
    let res = await fetch(ruta, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("_token")
      },
      body: JSON.stringify(filtro)
    });

    if (res.ok) {
      let response = await res.blob();
      let blob = new Blob([response], {
        type: "application/pdf"
      });
      var fileUrl = URL.createObjectURL(blob);
      var wnd = window.open(fileUrl, "_blank");
      await this.sleep(100);
      wnd.print();
    } else throw true;
  } catch (error) {
    console.log("error " + JSON.stringify(error));
    //Vue.prototype.$toast("Se ha iniciado sesión en otro lugar", {
    //  color: "blue"
    //});
    //commit("Auth/logout", null, { root: true });
    //router.push("login");
  }
}

export async function exportarServicios({ commit }, filtro) {
  try {
    console.log("Token: " + window.localStorage.getItem("_token"));
    //console.log('Filtro: ' + JSON.stringify(filtro))

    let ruta = Vue.prototype.$apiRoute + "expediciones/exportar";
    let res = await fetch(ruta, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("_token")
      },
      body: JSON.stringify(filtro)
    });

    if (res.ok) {
      let response = await res.blob();
      let blob = new Blob([response], {
        type: "application/octet-stream"
        //type: "application/vnd.ms-excel"
      });

      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Servicios.xls";
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else throw true;
  } catch (error) {
    console.log("error " + JSON.stringify(error));
    Vue.prototype.$toast(JSON.stringify(error), {
      color: "blue"
    });
    //Vue.prototype.$toast("Se ha iniciado sesión en otro lugar", {
    //  color: "blue"
    //});
    //commit("Auth/logout", null, { root: true });
    //router.push("login");
  }
}

export async function importarServicio({ commit }, file) {
  try {
    console.log("Token: " + window.localStorage.getItem("_token"));
    console.log("importarServicio " + file);

    let formData = new FormData();
    formData.append("file", file);

    let res = await fetch(Vue.prototype.$apiRoute + "expediciones/importar", {
      method: "POST",
      headers: {
        Accept: "application/json",
        //"Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("_token")
      },
      body: formData
    });

    let resJson = await res.json();

    if (!res.ok) {
      Vue.prototype.$toast(resJson.Message, { color: "red" });
    } else {
      Vue.prototype.$toast(resJson, {
        color: "green"
      });
    }
  } catch (error) {
    commit("errorMessage", error.message);
  } finally {
    console.log("La petición para importar servicios ha finalizado.");
  }
}

export async function addService({ commit }, servicio) {
  try {
    //console.log(JSON.stringify(servicio));
    console.log("Token: " + window.localStorage.getItem("_token"));

    let res = await fetch(Vue.prototype.$apiRoute + "expediciones/v2", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("_token")
      },
      body: JSON.stringify(servicio)
    });

    let responseText = await res.text();
    let resJson = {};
    try {
      resJson = responseText ? JSON.parse(responseText) : {};
    } catch (error) {
      resJson = { Message: responseText };
    }

    if (!res.ok) {
      Vue.prototype.$toast(resJson.Message || responseText || "No se pudo grabar el servicio", { color: "red" });
    } else {
      Vue.prototype.$toast(i18n.t("mensajes.servicioCreado"), {
        color: "green"
      });
    }

    let resp = {
      estado: res.ok,
      respuesta: resJson
    }
    console.log("Respuesta crear: "+JSON.stringify(resp));
    return resp;
  } catch (error) {
    Vue.prototype.$toast(error.message, {
      color: "red"
    });
    return {
      estado: false,
      respuesta: error
    };
  }
}

export async function updateService({ commit }, servicio) {
  console.log("Actualizo servicio");
  try{
    console.log("Token: " + window.localStorage.getItem("_token"));
    let res = await fetch(Vue.prototype.$apiRoute + "expediciones", {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("_token")
      },
      body: JSON.stringify(servicio)
    });

    if (!res.ok) {
      let resJson = await res.json();
      Vue.prototype.$toast(resJson.Message, { color: "red" });
    } else {
      Vue.prototype.$toast(i18n.t("mensajes.servicioActualizado"), { color: "green" });
    }

    let resp = {
      estado: res.ok,
      respuesta: ""
    }
    return resp;
  }catch(error){
    console.log("Error actualizar: "+JSON.stringify(error));
    Vue.prototype.$toast(JSON.stringify(error), {
      color: "red"
    });
  }
}

export async function deleteService({ commit }, servicio) {
  console.log("Token: " + window.localStorage.getItem("_token"));
  //console.log("delete: " + servicio.ReferenciaVia);
  let res = await fetch(Vue.prototype.$apiRoute + "expediciones?ReferenciaEntrega=" + servicio.ReferenciaVia + "&NumeroOrden=" + servicio.Codigo, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + window.localStorage.getItem("_token")
    }
  });
  let resJson = await res.json();
  if (!res.ok) {
    Vue.prototype.$toast(resJson.Message, { color: "red" });
  } else {
    Vue.prototype.$toast(i18n.t("mensajes.servicioEliminado"), {
      color: "green"
    });
  }
  return res.ok;
}

export async function getTracking({ commit }, servicio) {
  //let codigo = servicio.ReferenciaVia;
  let codigo = servicio.Codigo;
  let res = await fetch(Vue.prototype.$apiRoute + "traking?ReferenciaEntrega=" + codigo, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + window.localStorage.getItem("_token")
    }
  });
  let resJson = await res.json();
  if (!res.ok) {
    Vue.prototype.$toast(resJson.Message, { color: "red" });
  }
  return {
    estado: res.ok,
    respuesta: resJson
  };
}

export async function obtenerPod({ commit }, servicio) {
  //let codigo = servicio.ReferenciaVia;
  let codigo = servicio.Codigo;
  let res = await fetch(Vue.prototype.$apiRoute + "traking/pod?ReferenciaEntrega=" + codigo, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + window.localStorage.getItem("_token")
    }
  });
  let resJson = await res.json();
  if (!res.ok) {
    Vue.prototype.$toast("POD no disponible", { color: "red" });
  }
  /*let response = {
    estado: res.ok,
    respuesta: resJson
  };*/
  //console.log("response" + JSON.stringify(response));
  return resJson;
}

export async function exportarPods({ commit }, filtro) {
  try {
    console.log("Token: " + window.localStorage.getItem("_token"));
    console.log("Filtro: " + JSON.stringify(filtro));

    let ruta = Vue.prototype.$apiRoute + "traking/pods";
    let res = await fetch(ruta, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("_token")
      },
      body: JSON.stringify(filtro)
    });

    if (res.ok) {
      let response = await res.blob();
      let blob = new Blob([response], {
        type: "application/zip"
      });

      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Pods.zip";
      link.click();
    } else throw true;
  } catch (error) {
    console.log("error " + JSON.stringify(error));
    Vue.prototype.$toast(JSON.stringify(error), {
      color: "red"
    });
    //Vue.prototype.$toast("Se ha iniciado sesión en otro lugar", {
    //  color: "blue"
    //});
    //commit("Auth/logout", null, { root: true });
    //router.push("login");
  }
}
